import React, { useState } from 'react';
import './ManualList.scss';
import ManualDialogList from './ManualDialogList';

/**
 * ManualList Component
 * @module
 * @param {func} getManual - Function to get manual
 * @param {func} getListManual - Function to get manual list
 * @param {manualProps} manualProps - Props for manual
 */
const ManualList = (props) => {
  const [isOpenManualDialogList, setIsOpenManualDialogList] = useState(false);
  // const [manualType, setManualType] = useState('');
  const [manualTitle, setManualTitle] = useState('');

  const handleOpen = async (manualType, title) => {
    await props.getListManual(manualType);
    setIsOpenManualDialogList(true);
    setManualTitle(title);
  };

  const handleCloseList = () => {
    setIsOpenManualDialogList(false);
  };

  return (
    <>
      <div>
        {props.manualProps.manualList.map((x) => (
          <div key={x.manualType} className="popis" onClick={() => handleOpen(x.manualType, x.title)}>
            {x.title}
          </div>
        ))}
      </div>
      <ManualDialogList
        manualProps={props.manualProps} // kvoli map :30 a desktruktorovi v dialogu to musi byt takto, nie spread {...props.manualProps}
        isOpenManualDialogList={isOpenManualDialogList}
        manualTitle={manualTitle}
        handleClose={handleCloseList}
        getManual={props.getManual}
      />
    </>
  )
}

export default ManualList;
